<template>
  <div class="fullBg">
    <div :bordered="false" class="announcementPage quill-editor ql-editor" dis-hover>
      <h2 class="center">{{announcementFrom.title}}</h2>
      <div class="descContaner">
        <div>
          <span class="label">公告类型</span>
          <span class="value">{{announcementFrom.announcementTypeLabel || '--'}}</span>
        </div>
        <div>
          <span class="label">发布时间</span>
          <span class="value">{{announcementFrom.publishTime || '--'}}</span>
        </div>
        <div>
          <span class="label">发布对象</span>
          <span class="value">{{announcementFrom.roleNames || '--'}}</span>
        </div>
      </div>
      <div
        class="ql-container ql-snow"
        style="border: none"
        v-html="announcementFrom.announcementContent"
      ></div>
    </div>
    <Spin fix v-if="spinShow">
      <Icon class="demo-spin-icon-load" size="18" type="load-c"></Icon>
    </Spin>
  </div>
</template>
<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  props: {
    id: {
      required: true
    },
    addCount: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      spinShow: false,
      announcementTypes: [],
      announcementFrom: {
        title: '',
        publishTime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        announcementTypes: [],
        publishOrgId: null,
        showPlatform: [],
        active: 1,
        announcementContent: '',
        showPlatform: []
      },
      dateOpt: {
        disabledDate: function (date) {
          return date && date.valueOf() < Date.now()
        }
      },
      platforms: [],
      orgOpts: {
        showSimple: true,
        calcDis: false,
        showTop: false,
        showAll: true,
        showNextLevel: false,
        // showNextLevel: this.$store.getters['userInfo/isAdmin'] ? true : (this.$store.getters['userInfo/establishments'].length > 0 ? true : false)
      },
      announcementAuditLogForm: {}
    }
  },
  computed: {
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    }
  },
  methods: {
    backList: function () {
      this.$router.push({ path: `/announcement/todo` })
    },
    getDetail: function () {
      let that = this
      that.spinShow = true
      let params = new this.$URLSearchParams()
      params.append("id", this.id)
      params.append("addCount", this.addCount)
      that.$axios.post(this.$apis.announcementApi.getDetail, params).then(res => {
        if (res.success) {
          that.announcementFrom = res.result || {}
          if (that.announcementFrom.publishTime) that.announcementFrom.publishTime = this.$moment(that.announcementFrom.publishTime).format("YYYY-MM-DD HH:mm:ss")
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取公告详情失败！")
      }).finally(() => {
        that.spinShow = false
      })
    },
    changeAnnouncementContent: function (html) {
      this.announcementFrom.announcementContent = html
      console.log('this.announcementFrom.announcementContent', this.announcementFrom.announcementContent)
    }
  },
  beforeMount () {
    this.getDetail()
  }
}
</script>

<style lang="less" scoped>
.announcementPage {
  user-select: none;
  .center {
    text-align: center;
    // margin-bottom: 10px;
  }

  .descContaner {
    display: flex;
    justify-content: center;
    line-height: 2rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    flex-wrap: wrap;

    > div {
      margin: 0 1rem;
      white-space: nowrap;

      .label {
        color: #888;
        margin-right: 5px;
        white-space: nowrap;
      }

      .value {
        color: #666;
      }
    }
  }
}
</style>